import React from 'react';
import { productTypes } from '../../utils/productHelpers';
import { formatDate } from '../../utils/helpers';

export const fisaMaturityLearnMoreUrl = '/maturity/disa';

export const fisaMaturityPageSources = {
    DashboardNotification: 'dashboard-maturity-notification',
    ManageAccountMaturity: 'manage-account-maturity',
    DisaProductDetails: 'disa-product-details',
};

export const maturityNoticeVariants = {
    Dashboard: 'dashboard',
    ManageAccount: 'manage-account',
};

export const getMaturityNoticeConfig = ({
    account,
    variant = maturityNoticeVariants.Dashboard,
    isMultiple = false,
    enableUpdatedMaturityCopy = false,
    }) => {
    const maturityDate = account?.maturity?.maturityDate
        ? formatDate(new Date(account.maturity.maturityDate))
        : '';
    const productType = account?.product?.productType;
    const isFrs = productType === productTypes.FixedTerm;
    const isFisa = productType === productTypes.FixedRateCashISA;
    const includeAccountNumber = variant === maturityNoticeVariants.Dashboard;
    const accountNumber = account?.accountNumber ? ` (${account.accountNumber})` : '';
    const isGroupedFisa = isFisa && account?.groupedAccountNumbers?.length > 1;
    const fisaProductName = isGroupedFisa
        ? account.product.name.replace(/ISA$/, 'ISAs')
        : account?.product?.name;

    if (isFisa) {
        return {
            title: `Your ${fisaProductName} ${isGroupedFisa ? 'are' : 'is'} maturing soon${includeAccountNumber ? accountNumber : ''}`,
            buttonText: 'Learn more',
            showMaturityDate: false,
            body: isGroupedFisa ? (
                    <>
                        We&apos;ll automatically open an Instant Access Cash ISA for each maturing account. On <b>{maturityDate}</b>,
                                                we&apos;ll transfer the savings from each account into its new Instant Access Cash ISA and pay any
                                                interest earned to your linked account.
                                            </>
                                        ) : enableUpdatedMaturityCopy ? (
                                            <>
                                                We&apos;ll automatically open an Instant Access Cash ISA for you. On <b>{maturityDate}</b>,
                                                we&apos;ll transfer your savings including any interest earned into an Instant Access Cash ISA.
                                            </>
                                        ) : (
                    <>
                        We&apos;ll automatically open an Instant Access Cash ISA for you. On <b>{maturityDate}</b>,
                        we&apos;ll transfer your savings into an Instant Access Cash ISA and pay any
                        interest earned to your linked account.
                    </>
                ),
        };
    }

    return {
        title: `Your ${account.product.name} is maturing soon${includeAccountNumber ? accountNumber : ''}`,
        buttonText: 'View your options',
        showMaturityDate: isFrs && isMultiple,
        body: (
            <>
                As a thank you for saving with us, we&apos;d like to offer you a renewal rate.
                The rate you receive will depend on the term you select.
            </>
        ),
    };
};
